import VerticalCard from "@src/app/components/ArticleCard/VerticalCard";
import SectionContainer from "@src/app/components/SectionContainer";
import type { BFFArticleCard } from "@src/app/types/bff";
import clsx from "clsx";
import { useState } from "react";

import GoogleAd, { GoogleAdTypeEnum } from "../_ads/GoogleAd/GoogleAd";

/**
 * Video Strip
 * @description use in Common Category Page & Home Page
 */
export default function VideoStrip({
  articles = [],
}: {
  articles: BFFArticleCard[];
}) {
  const [isAdEmpty, setIsAdEmpty] = useState(true);

  if (!articles.length) {
    return null;
  }

  return (
    <SectionContainer
      className="lg:px-[24px] lg:pb-[16px]"
      theme="dark"
      title="视频"
      more="/videos"
      testId="video"
    >
      <div className="w-full lg:flex">
        <div className="grid flex-1 grid-cols-12">
          {/* Video articles */}
          {(isAdEmpty ? articles : articles.slice(0, 3)).map(
            (article, index) => {
              return (
                <VerticalCard
                  key={article.id + index}
                  theme="dark"
                  className={clsx(
                    "col-span-12",
                    isAdEmpty ? "lg:col-span-3" : "lg:col-span-4",
                  )}
                  article={article}
                  showSubHeader={false}
                  descStyle="px-0 pb-0"
                  infoStyle="lg:!min-h-[84px]"
                />
              );
            },
          )}
        </div>

        <GoogleAd
          className="box-content px-3 py-4 lg:w-[300px]"
          type={GoogleAdTypeEnum.IMU1}
          onSlotRenderEnded={(event) => {
            setIsAdEmpty(event.isEmpty);
          }}
        />
      </div>
    </SectionContainer>
  );
}
